import { render, staticRenderFns } from "./FeatureMassMove.vue?vue&type=template&id=525fff54"
import script from "./FeatureMassMove.vue?vue&type=script&lang=js"
export * from "./FeatureMassMove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports